import axios from "axios";
import { setUserImage } from './UserActions';
import { updateProfileImage } from './MlAdminUserActions';
import store from "redux/Store";

export const uploadProfileImage = (formData, done = null) => (dispatch) => {

  const { 
    user, 
    mladminuser:{
      editing
    }
   } = store.getState();
  let config = {
    header: {
      "Content-Type": "multipart/form-data",
    },
  };
    axios
      .post(`/image`, formData, config)
      .then((data) => {
        if(user.id === data.data?.id){
          dispatch(setUserImage(data.data.imageUrl));
        }
        if(editing && editing.id === user.id){
          dispatch(updateProfileImage(data.data.imageUrl));
        }
        if(done) done(data.data.imageUrl, null);
      })
      .catch((err) => {
        console.error("ProfileImageUpload", "ImageActions", "uploadProfileImage", [formData], err);
      });
  };


export const uploadGroupImage = (formData, done = null) => (dispatch) => {

  let config = {
    header: {
      "Content-Type": "multipart/form-data",
    },
  };
    axios
      .post(`/image`, formData, config)
      .then((data) => {
        if(done) done(data.data.imageUrl, null);
      })
      .catch((err) => console.log(err));
  };
  